import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK,
} from '../../../../actions/actionTypes';

const detectionLinkSave = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK
);

export default detectionLinkSave;
